import { render, staticRenderFns } from "./datachoose.vue?vue&type=template&id=f9b53e82&scoped=true"
import script from "./datachoose.vue?vue&type=script&lang=js"
export * from "./datachoose.vue?vue&type=script&lang=js"
import style0 from "./datachoose.vue?vue&type=style&index=0&id=f9b53e82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b53e82",
  null
  
)

export default component.exports